var React = require('react');

function ScrollDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff}")),React.createElement("path",{"className":"cls-1","d":"M12.07 9.44l-12-8.18L.92 0l11.15 7.6L23.23 0l.84 1.26-12 8.18z","key":1}),React.createElement("path",{"className":"cls-1","d":"M12.07 14.65L0 6.47l.85-1.26 11.22 7.6 11.22-7.6.85 1.26-12.07 8.18z","key":2})]);
}

ScrollDown.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24.14 14.65"};

module.exports = ScrollDown;

ScrollDown.default = ScrollDown;
